module.exports = __webpack_public_path__ + "media/images/flags/16/Bulgaria-29fb43f5dba5423fb936a9035fac5c44.png";